module.exports = __webpack_public_path__ + "img/0.21d1f7c.png";